import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './Button';
import { isProdEnv } from '../utils/environment';
import styles from './Header.module.scss';

const Header: React.FC = () => {
  const { user, signOut } = useAuth();

  const handleSignOut = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <header className={`${styles.header} ${!isProdEnv() ? styles.envDev : ''}`.trim()}>
      <div className={styles.headerInner}>
        <div className={styles.headerContent}>
          <div className={styles.headerLeft}>
            <a href="/" className={styles.siteName}>
              Match Central
            </a>
          </div>
          <div className={styles.headerRight}>
            <Button variant="inverse" size="small" onClick={handleSignOut}>
              Sign Out
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
